var React = require('react');

function TeamInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.5676 0C4.73126 0 0 5.06996 0 11.3241C0 17.5782 4.73127 22.6481 10.5676 22.6481H10.8489C4.85449 22.6652 0 27.8777 0 34.3052C0 39.7761 3.51701 44.3668 8.26039 45.6226C3.53366 46.7505 0 51.271 0 56.6759C0 62.93 4.73127 68 10.5676 68H58.4324C64.2687 68 69 62.93 69 56.6759C69 51.271 65.4663 46.7505 60.7396 45.6226C65.483 44.3668 69 39.7761 69 34.3052C69 27.8777 64.1455 22.6652 58.1511 22.6481H58.4324C64.2687 22.6481 69 17.5782 69 11.3241C69 5.06996 64.2687 0 58.4324 0H10.5676Z","fill":"#C4FE3A"}));
}

TeamInline.defaultProps = {"width":"69","height":"68","viewBox":"-15 -16 100 100","fill":"none"};

module.exports = TeamInline;

TeamInline.default = TeamInline;
